"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupServiceInstance = void 0;
const client_1 = require("@rws-framework/client");
const sweetalert2_1 = __importDefault(require("sweetalert2"));
class PopupService extends client_1.RWSService {
    async firePopup(popupOptions, html) {
        if (html) {
            const content = popupOptions.text || '';
            popupOptions.html = content;
            delete popupOptions.text;
        }
        return sweetalert2_1.default.fire(popupOptions);
    }
    error(text, html, confirmText = 'popup.ok'.t()) {
        this.firePopup({
            title: 'popup.error'.t(),
            text,
            icon: 'error',
            confirmButtonText: confirmText
        }, html);
    }
    alert(text, html, confirmText = 'popup.ok'.t()) {
        this.firePopup({
            title: 'popup.alert'.t(),
            text,
            icon: 'info',
            confirmButtonText: confirmText
        }, html);
    }
    async confirm(text, html, title, confirmText = 'popup.yes'.t(), denyText = 'popup.no'.t()) {
        const popupData = await this.firePopup({
            title: title || 'popup.confirm'.t(),
            text,
            icon: 'question',
            confirmButtonText: confirmText,
            showDenyButton: true,
            denyButtonText: denyText
        }, html);
        return popupData.isConfirmed && !popupData.isDenied && !popupData.isDismissed;
    }
}
exports.PopupServiceInstance = PopupService;
exports.default = PopupService.getSingleton();
